import { Alert } from "@monolith-forensics/monolith-ui";
import { useFeatures } from "@/contexts/FeaturesContext";
// By path, not the EvidenceFiles barrel, which imports EvidencePhotos back.
import { StyledModalAlert } from "@/Features/EvidenceFiles/StyledModalAlert";
import { LearnMoreLink } from "@/Features/EvidenceFiles/ManagedRowIcon";

const PLACES = "This photo is also in Case Files and this item's Files tab.";

const CONSEQUENCE = {
  delete: "Deleting it here also deletes it from those places.",
  rename: "Changes here also show up in those places.",
};

/**
 * The alert in the Photos tab's Delete and Rename modals (ENG-2133): a warning
 * before a delete, a note on a rename. Only with evidence_files_in_case_files
 * on, since the photo shows nowhere else while it's off.
 */
export const EvidencePhotoModalAlert: React.FC<{
  kind: "delete" | "rename";
}> = ({ kind }) => {
  const { hasFeatures, FEATURES } = useFeatures();

  if (!hasFeatures([FEATURES.EVIDENCE_FILES_IN_CASE_FILES])) return null;

  return (
    <StyledModalAlert data-testid={`evidence-photo-${kind}-alert`}>
      <Alert variant={kind === "delete" ? "warning" : "info"}>
        <div className="modal-alert-body">
          {PLACES} {CONSEQUENCE[kind]} <LearnMoreLink />
        </div>
      </Alert>
    </StyledModalAlert>
  );
};
